import { Link } from 'react-router';

import { EmptyState } from '../components/ui.jsx';
import { useT } from '../lib/i18n.js';

export function NotFound() {
  const t = useT();
  return (
    <EmptyState
      page
      title={t('notfound.title')}
      action={
        <Link to="/" className="font-semibold text-accent underline">
          {t('notfound.home')}
        </Link>
      }
    >
      {t('notfound.body')}
    </EmptyState>
  );
}
